package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_11_22_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-11-22")
@Composable
public fun Log_2025_11_22(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Cronberry",
        ogTitle = "Cronberry",
        date = LocalDate(2_025, 11, 22),
        aiHint = "Description is a joke.",
        ogDescription = "Lornella hands Cronberry a shot glass of vodka and whispers “just a splash of vodka and I’d love to drink you up.”",
        ogImage = "images/crestOfThradorisFox.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A simple graphic of a yellow crown with a crack down the middle, on a dark red background. This is Lord Fox's family crest.",
    ) {
        SessionDayHeader(dayId = "shimmer-8", dateString = "Shimmer 8", cardImageSrc = "images/crestOfThradorisFoxCrop.svg")
        Log_2025_11_22_Day_1()
    }
}
